export default __webpack_public_path__ + "static/media/livetv.64ab4dbd.svg";